import { getCategories, getCategoryTrail, listed } from "@/api/categories";
import { Categories } from "@/types/categories";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from 'vue-property-decorator';
import { carryListing } from '@/api/listingCarry';

@Component({})
export default class CatNav extends Vue {
  categories: Categories = [];
  isCatPage = false
  isEndCatPage = false
  curCtName = ''
  panel: any = null
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    this.calcCat()
  }
  async isCategoryPage() {
    this.isCatPage = true
    this.panel = 0
    const path = this.$route.path
    const trail = await getCategoryTrail(this.$route.params.cat.split('/'))
    if (path !== this.$route.path) return
    const node = trail ? trail[trail.length - 1] : undefined
    const segments = this.$route.params.cat.split('/')
    this.curCtName = node ? node.name : segments[segments.length - 1]
    const children = node ? listed(node.children) : []
    this.categories = children.map((child) => ({ id: child.id, name: child.name, href: child.href }))
    this.isEndCatPage = !children.length
  }
  async isHomePage() {
    this.isCatPage = false
    this.isEndCatPage = false
    let { fullCategories } = await getCategories();
    this.categories = fullCategories;
  }
  // The list on the next category page keeps this page's filters and sort.
  // router-link would navigate first (the new list mounts before a click
  // listener of ours runs), so the link carries and navigates itself; a
  // modified click still opens a new tab
  onCategoryLink(e: MouseEvent, href: string) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    e.preventDefault()
    carryListing()
    this.$router.push(href)
  }
  calcCat() {
    switch (this.$route.name) {
      case "home":
        this.isHomePage()
        break;
      case "categories":
        this.isCategoryPage()
        break;
      default:
        break;
    }
  }
}
